import Cookies from 'js-cookie';
import {jwtDecode} from "jwt-decode";

export const tokerUser = () => {
    return new Promise((resolve, reject) => {
        resolve(Cookies.get('fansa_token'))
    })
}

export const infoUser = () => {
    return new Promise(async (resolve, reject) => {
        const tokenUser = await tokerUser()
        if (tokenUser === undefined) {
            resolve(tokenUser)
        } else {
            var decodeToken = jwtDecode(tokenUser);
            resolve(decodeToken)
        }
    })
}

export const deleteCookie = () => {
    return new Promise(async (resolve, reject) => {
        resolve(Cookies.remove('fansa_token'))
    })
}

export const privilegeUser = () => {
    return new Promise(async (resolve, reject) => {
        const user = await infoUser()
        if (user !== undefined && (user.role === 'admin' || user.role === 'agent' || user.role === 'client')) {
            resolve(true)
        } else {
            resolve(false)
        }
    })
}